export const INVESTMENT_HISTORY_HEAD = [
  {
    key: "coin",
    name: "Coin",
    align: "left",
  },
  {
    key: "portfolioOwner",
    name: "Portfolio Owner",
    align: "left",
  },
  {
    key: "side",
    name: "Side",
    align: "left",
  },
  {
    key: "state",
    name: "State",
    align: "left",
  },
  {
    key: "amount",
    name: "Amount",
    align: "left",
  },
  {
    key: "fee",
    name: "Fee",
    align: "left",
  },
  {
    key: "comment",
    name: "Comment",
    align: "left",
  },
  {
    key: "date",
    name: "Date/Time",
    align: "left",
  },
  {
    key: "dateTimeEdit",
    name: "Date/Time Edit",
    align: "left",
  },
];
